import { render } from "./iconItem.vue?vue&type=template&id=8d7f0d74&scoped=true"
import script from "./iconItem.vue?vue&type=script&lang=js"
export * from "./iconItem.vue?vue&type=script&lang=js"

import "./iconItem.vue?vue&type=style&index=0&id=8d7f0d74&scoped=true&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d7f0d74"]])

export default __exports__